<div class="dialog-content-container">
  <div class="dialog-header">
    <h3 class="dialog-title">Escanear el código QR</h3>
  </div>
  <div class="dialog-content">
    <p class="dialog-content-text">
      Escanee el código QR con la aplicación de autenticación por dos factores.
    </p>

    <div class="qr-block">
      <div class="qr-wrapper">
        @if (loadingComponent){
        <p-skeleton height="180px" width="180px" class="my-2"></p-skeleton>
        } @else{
        <qrcode
          [qrdata]="totpUri"
          [allowEmptyString]="true"
          [width]="200"
          [errorCorrectionLevel]="'M'"
        ></qrcode>
        @if (isExpired){
        <div class="qr-overlay">
          <div class="overlay-content">
            <span class="text-sm text-white">Código QR vencido</span>
            <button
              pButton
              type="button"
              class="p-button text-sm text-white"
              [disabled]="!canResend"
              (click)="regenerate()"
            >
              {{
                canResend
                  ? "Regenerar"
                  : "Regenerar (" + resendCooldownSeconds + "s)"
              }}
            </button>
          </div>
        </div>
        } }
      </div>
      <div class="flex align-items-center justify-content-between">
        <p class="text-sm">Clave secreta:</p>
        @if (loadingComponent) {
        <p-skeleton height="33px" width="164px" class="mx-2"></p-skeleton>
        } @else {
        <p class="uri-preview text-xs w-6">{{ secretKey }}</p>
        }
        <button
          pButton
          type="button"
          class="p-button-secondary"
          (click)="copyToClipboard()"
        >
          <i class="pi pi-copy"></i>
        </button>
      </div>
      <div class="flex align-items-center gap-1 justify-content-between">
        <span class="text-xs">Tiempo restante: {{ remainingLabel }}</span>
        <button
          pButton
          type="button"
          class="p-button-text text-sm"
          [disabled]="!canResend"
          (click)="regenerate()"
        >
          {{
            canResend
              ? "Regenerar"
              : "Regenerar (" + resendCooldownSeconds + "s)"
          }}
        </button>
      </div>
      @if (isExpired){
      <div class="text-xs text-color-secondary mt-1">
        El código ha vencido. Genera un nuevo QR para continuar.
      </div>
      }
    </div>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="w-full">
      <div class="field mb-3">
        <p-inputOtp
          id="code"
          formControlName="code"
          [length]="6"
          [integerOnly]="true"
          [autofocus]="true"
          styleClass="w-full h-3rem text-xl"
        ></p-inputOtp>
        <div
          *appFormFieldError="form.get('code'); let errors"
          class="error-message-small"
        >
          @for (error of errors; track error) {
          <div>{{ error }}</div>
          }
        </div>
      </div>
      <div class="actions">
        <button
          pButton
          type="submit"
          class="p-button-primary w-full"
          [disabled]="form.invalid || submitting || isExpired"
        >
          {{ submitting ? "Verificando..." : "Confirmar" }}
        </button>
      </div>
    </form>
  </div>
</div>
